import React from 'react';

import { SVGComponentProps } from './svg.types';

const CalendarDashedDateSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block align-middle ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.25 1.15898H10.5V0.917216C10.5 0.410119 10.1081 0 9.625 0C9.14195 0 8.75 0.410119 8.75 0.917216V1.15898H5.25V0.917216C5.25 0.410119 4.85805 0 4.375 0C3.89195 0 3.5 0.410119 3.5 0.917216V1.15898H1.75C0.783898 1.15898 0 1.9807 0 2.99341V12.1656C0 13.1783 0.783898 14 1.75 14H12.25C13.2161 14 14 13.1783 14 12.1656V2.99341C14 1.97996 13.2161 1.15898 12.25 1.15898ZM12.5 12.1656H1.75V4H12.25L12.5 12.1656ZM3.25 6.50005C3.25 6.08584 3.58579 5.75005 4 5.75005H9C9.41421 5.75005 9.75 6.08584 9.75 6.50005C9.75 6.91427 9.41421 7.25005 9 7.25005H4C3.58579 7.25005 3.25 6.91427 3.25 6.50005ZM4 8.25008C3.58579 8.25008 3.25 8.58587 3.25 9.00008C3.25 9.41429 3.58579 9.75008 4 9.75008H8C8.41421 9.75008 8.75 9.41429 8.75 9.00008C8.75 8.58587 8.41421 8.25008 8 8.25008H4Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CalendarDashedDateSVG;
